import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Metrics',
      type: 'report-card',
      content: {
        '[]': [
          {
            '{}': {
              name: 'Total',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'TDC',
                      value: {
                        '{}': {
                          tooltip:
                            'Total Direct Cost - All direct expenses charged to a research project.',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'MTDC',
                      value: {
                        '{}': {
                          tooltip:
                            'Modified Total Direct Cost - TDC excluding equipment, capital costs, patient care, tuition, and large subawards.',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdcAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'IDC-R',
                      value: {
                        '{}': {
                          tooltip: 'Total Indirect Cost Recovery',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'glExpenses',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'idcrAmount',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.000001,
                                suffix: 'M',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'ASF',
                      value: {
                        '{}': {
                          aside: 'Sq. Ft.',
                          tooltip: 'ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                scalar: 0.001,
                                suffix: 'K',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Density',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'TDC Density',
                      value: {
                        '{}': {
                          tooltip: 'Total TDC / Total ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                if: [
                                  [
                                    {
                                      and: [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': 'rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'asf',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              null,
                                            ],
                                          },
                                        },
                                        {
                                          '!=': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            0,
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'tdcAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  0,
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'MTDC Density',
                      value: {
                        '{}': {
                          tooltip: 'Total MTDC / Total ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                if: [
                                  [
                                    {
                                      and: [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': 'rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'asf',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              null,
                                            ],
                                          },
                                        },
                                        {
                                          '!=': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            0,
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'mtdcAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  0,
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'IDC-R Density',
                      value: {
                        '{}': {
                          tooltip: 'Total IDC-R / Total ASF',
                          emphasis: {
                            'fmt.num': [
                              {
                                if: [
                                  [
                                    {
                                      and: [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': 'rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'asf',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              null,
                                            ],
                                          },
                                        },
                                        {
                                          '!=': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            0,
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'idcrAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  0,
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
          {
            '{}': {
              name: 'Other',
              values: {
                '[]': [
                  {
                    '{}': {
                      name: 'Utilization',
                      value: {
                        '{}': {
                          tooltip:
                            'Percentage of ASF actively used for research.',
                          emphasis: {
                            'fmt.num': [
                              {
                                if: [
                                  [
                                    {
                                      and: [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': 'rooms',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'sqft',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              null,
                                            ],
                                          },
                                        },
                                        {
                                          '!=': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'sqft',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            0,
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'sqft',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  0,
                                ],
                              },
                              {
                                ',': true,
                                '.': {
                                  max: 2,
                                  min: 2,
                                },
                                scalar: 100,
                                suffix: '%',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      name: 'Effective Recovery',
                      value: {
                        '{}': {
                          tooltip: 'IDC-R / MTDC',
                          emphasis: {
                            'fmt.num': [
                              {
                                if: [
                                  [
                                    {
                                      and: [
                                        {
                                          not: {
                                            '=': [
                                              {
                                                '+': {
                                                  '->': [
                                                    {
                                                      '@': 'glExpenses',
                                                    },
                                                    {
                                                      '@>': [
                                                        {
                                                          '@$': '$value',
                                                        },
                                                        'mtdcAmount',
                                                      ],
                                                    },
                                                  ],
                                                },
                                              },
                                              null,
                                            ],
                                          },
                                        },
                                        {
                                          '!=': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'glExpenses',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'mtdcAmount',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            0,
                                          ],
                                        },
                                      ],
                                    },
                                    {
                                      '/': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'idcrAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'glExpenses',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'mtdcAmount',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                  0,
                                ],
                              },
                              {
                                ',': true,
                                '.': {
                                  max: 2,
                                  min: 2,
                                },
                                scalar: 100,
                                suffix: '%',
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                ],
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2025',
        },
        start: {
          $date: '1/1/2025',
        },
      },
    },
  },
  subqueries: {
    rooms: {
      filter: {
        or: [
          {
            '=': [
              {
                '@$': 'spaceType',
              },
              null,
            ],
          },
          {
            in: [
              {
                '@.': [
                  '!space_use',
                  {
                    ref: {
                      entity: '!group',
                    },
                  },
                ],
              },
              {
                '@>': [
                  {
                    '@$': 'spaceType',
                  },
                  'ent:!space_use:!group',
                ],
              },
            ],
          },
        ],
      },
      period: {
        '@$': 'focusedRange',
      },
      target: 'ent:!space:!room',
      selection: {
        '{}': {
          asf: {
            '*': [
              {
                '@.': '!sqft',
              },
              {
                if: [
                  [
                    {
                      and: [
                        {
                          not: {
                            '=': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'weights',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'value',
                                      ],
                                    },
                                  ],
                                },
                              },
                              null,
                            ],
                          },
                        },
                        {
                          '!=': [
                            {
                              '+': {
                                '->': [
                                  {
                                    '@': 'weights',
                                  },
                                  {
                                    '@>': [
                                      {
                                        '@$': '$value',
                                      },
                                      'value',
                                    ],
                                  },
                                ],
                              },
                            },
                            0,
                          ],
                        },
                      ],
                    },
                    {
                      '/': [
                        {
                          '+': {
                            '->': [
                              {
                                '@': 'weights',
                              },
                              {
                                '*': [
                                  {
                                    '@>': [
                                      {
                                        '@$': '$value',
                                      },
                                      'value',
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '@$': '$value',
                                      },
                                      'allowable',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                        {
                          '+': {
                            '->': [
                              {
                                '@': 'weights',
                              },
                              {
                                '@>': [
                                  {
                                    '@$': '$value',
                                  },
                                  'value',
                                ],
                              },
                            ],
                          },
                        },
                      ],
                    },
                  ],
                  0,
                ],
              },
            ],
          },
          sqft: {
            '@.': '!sqft',
          },
        },
      },
      subqueries: {
        weights: {
          ref: {
            attr: 'attr:ent#!space_funcl#!entry:!space',
            inherit: '-',
          },
          filter: {
            '!=': [
              {
                '@.': '!weight',
              },
              0,
            ],
          },
          target: 'ent:!space_funcl:!entry',
          selection: {
            '{}': {
              value: {
                '@.': '!weight',
              },
              allowable: {
                if: [
                  [
                    {
                      '!=': [
                        {
                          '@': 'funcIdCat',
                        },
                        null,
                      ],
                    },
                    1,
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            funcIdCat: {
              ref: {
                attr: 'attr:ent#!space_funcl#!entry:!func_space',
              },
              target: 'ent:!func_space:!func',
              selection: {
                '@.': [
                  '!func_idc',
                  {
                    ref: {
                      entity: '!cat',
                    },
                  },
                ],
              },
            },
          },
        },
        roomOrgSpace: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          target: 'ent:!org_space:!entry',
        },
      },
    },
    glExpenses: {
      period: {
        '@$': 'focusedRange',
      },
      target: 'ent:!projects:!proj',
      selection: {
        '{}': {
          tdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'projectGlExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'tdcAmount',
                  ],
                },
              ],
            },
          },
          idcrAmount: {
            '+': {
              '->': [
                {
                  '@': 'projectGlExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'idcrAmount',
                  ],
                },
              ],
            },
          },
          mtdcAmount: {
            '+': {
              '->': [
                {
                  '@': 'projectGlExpenses',
                },
                {
                  '@>': [
                    {
                      '@$': '$value',
                    },
                    'mtdcAmount',
                  ],
                },
              ],
            },
          },
        },
      },
      subqueries: {
        projectGlExpenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '{}': {
              tdcAmount: {
                if: [
                  [
                    {
                      not: {
                        '=': [
                          {
                            '@': 'costType',
                          },
                          'IDC',
                        ],
                      },
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              idcrAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'IDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
              mtdcAmount: {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@': 'costType',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@.': '!amount',
                    },
                  ],
                  0,
                ],
              },
            },
          },
          subqueries: {
            costType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!cost_type',
              },
            },
          },
        },
      },
    },
  },
}
